import {createEvent, restore}  from "effector";
import { tryParseJSON } from "./functions";
import {getCustomUserAgent} from "./customUserAgent";

interface ILSUserAgentData {
    uuid?: string,
    session?: string,
    phone?: string,
    selected_account?: string,
}

// id выбранного лицевого счёта — чтобы после перезагрузки открывался тот же ЛС, а не первый.
export function getSelectedAccountId(): string {
    return lsGetUserAgentDataItem(getCustomUserAgent(), "selected_account")
}

export function setSelectedAccountId(id: string) {
    return lsSetUserAgentDataItem(getCustomUserAgent(), "selected_account", id)
}

// Ключ хранилища = Custom-User-Agent текущей компании (asblk/lk/krklk/oirclk).
// Раньше здесь был захардкожен UA АСБ, из-за чего для других компаний
// логин писал токены под свой ключ, а чтение шло из ASB-ключа → uuid/session пустые.
export function getPhone(): string {
    return lsGetUserAgentDataItem(getCustomUserAgent(), "phone")
}

export function setPhone(uuid: string) {
    return lsSetUserAgentDataItem(getCustomUserAgent(), "phone", uuid)
}

export function getUuidAndSession() {
    return {uuid: getUuid(), session: getSession()}
}

export function getUuid(): string {
    return lsGetUserAgentDataItem(getCustomUserAgent(), "uuid")
}

export function setUuid(uuid: string) {
    return lsSetUserAgentDataItem(getCustomUserAgent(), "uuid", uuid)
}

export function getSession(): string {
    return lsGetUserAgentDataItem(getCustomUserAgent(), "session")
}

export function setSession(session: string) {
    return lsSetUserAgentDataItem(getCustomUserAgent(), "session", session)
}
export function getEmail(): string {
    return lsGetUserAgentDataItem(getCustomUserAgent(), "email")
}
export function setEmail(email: string) {
    return lsSetUserAgentDataItem(getCustomUserAgent(), "email", email)
}
export function removeStorageData() {
    localStorage.removeItem(getCustomUserAgent())
}

export function lsRemoveUserAgentData(ua: string) {
    localStorage.removeItem(ua)
}

export function lsSetUserAgentDataItem(ua: string, key: string, val: string) {
    let data = lsGetUserAgentData(ua)
    //@ts-ignore
    data[key] = val
    lsSetUserAgentData(ua, data)
}

export function lsGetUserAgentDataItem(ua: string, key: string): string{
    //@ts-ignore
    let val = lsGetUserAgentData(ua)[key]
    return val == undefined ? "" : val as string
}

export function lsSetUserAgentData(ua: string, data: ILSUserAgentData) {
    localStorage.setItem(ua, JSON.stringify(data))
}

export function lsGetUserAgentData(ua: string): ILSUserAgentData {
    let data = tryParseJSON(localStorage.getItem(ua))
    return data as ILSUserAgentData
}
